import React from "react";

//* ReactFlow Library
import { ReactFlowProvider } from "reactflow";

//* Components
import Bracket from "./Bracket";
import BracketView from "./BracketView";
import BracketMini from "./BracketMini";

//** Import Context
import { BracketStateProvider } from "./context/BracketStateContext";

//* Import CSS/Style
import "reactflow/dist/style.css";
import "./css/custom.css";
import "./css/node.css";

const ReactFlowWrapper = ({
  isFront = false,
  whiteboard = false,
  ...props
}) => {
  return (
    <ReactFlowProvider>
      {whiteboard ? (
        <BracketMini {...props} />
      ) : isFront ? (
        <BracketView {...props} />
      ) : (
        <BracketStateProvider>
          <Bracket {...props} />
        </BracketStateProvider>
      )}
    </ReactFlowProvider>
  );
};

export default ReactFlowWrapper;
